import { Content } from "./ContentBase";
import { HtmlBuilder } from "./HtmlBuilder";
import {ComponentType} from "./ContentComponent";

export function CreateContentTemplateResult(tr:TemplateResult,setContent:(newContent:Node)=>void,curComp:ComponentType):Content {
  let Live=tr.bldr.MakeLive(tr.args,curComp);
  setContent(Live.ContentNode);
  return {
    Update:(v:TemplateResult)=>Live.Update(v.args),
    Unload:Live.Unload,
    MatchForUpdate:(v:TemplateResult)=>v.bldr===tr.bldr
  }
}

export class TemplateResult {
  bldr:HtmlBuilder;
  args:any[];
  constructor(bldr:HtmlBuilder,args:any[]) {
    this.bldr=bldr;
    this.args=args;
  }
}